import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Delete as DeleteIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import WithRouter from 'custom/withRouter';
import { selectCampaignModel, selectCampaignSelectedCategories } from 'selectors/entitySelector';
import util from 'library/util';
import { campaignEditCrumb } from 'utils/breadcrumbInfo';
import { formError, formInput, initializeCampaignForm, clearDialogItemsCampaign, clearFormInput, clearFormErrors } from 'actions/FormActions';
import { showSnackbar, showError } from 'actions/CommonActions';
import { CampaignDiscountType } from 'constants/enums';
import { saveBulkCampaign, getCategories, getProductsCampaign, getCampaign, getPriceMatrices, getCategoriesByBranchs } from 'actions/EntityActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import SelectInput from 'screens/components/basic/SelectInput';
import CardSimple from 'screens/components/basic/CardSimple';
import ToggleInput from 'screens/components/basic/ToggleInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import TextInput from 'screens/components/basic/TextInput';
import LOOKUP from 'constants/lookup';
import CheckInput from 'screens/components/basic/CheckInput';
import DialogHeader from 'screens/components/basic/DialogHeader';
import TimePickerInput from 'screens/components/basic/TimePickerInput';
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';
import Pagination from 'screens/components/basic/Pagination';
import DecimalInput from 'screens/components/basic/DecimalInput';
import RadioInput from 'screens/components/basic/RadioInput';
import Grid from 'screens/components/basic/Grid';
import BranchMultiSelectAutoCompleteInput from 'screens/components/basic/BranchMultiSelectAutoCompleteInput';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
import GenericTable from 'screens/components/advanced/GenericTable';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';

class CampaignSave extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            status: '',
            activePage: 1,
            itemsPerPage: 25,
            dialogProducts: false,
            errorSelectedCategories: false,
            errorNoAddedItems: false,
            productCategories: [],
            products: [],
            productsPriceByQuantity: [],
            orderBy: 'ASC',
            sortBy: 'Id'
        };
    }

    componentWillMount = () => {
        const capaignId = this.props.params.id;
        if (capaignId) {
            this.setState({ status: "EDIT" });
            this.props.getCampaign(capaignId, this.props.branchId);
        }
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
    }

    componentWillUnmount = () => {
        this.props.init(this.props.name);
    }

    componentWillReceiveProps = (newProps) => {
        if (newProps.saveTimeStamp && this.props.saveTimeStamp !== newProps.saveTimeStamp) {
            if (newProps.saveSuccess === true)
                this.saveSuccess();
            else
                this.saveFailure(newProps.saveError);
        }

        if (this.props.campaignModel && newProps.campaignModel && this.campaignModel !== newProps.campaignModel) {
            if (this.props.campaignModel.DiscountType !== newProps.campaignModel.DiscountType && this.state.status === 'ADD') {
                this.props.formInput(null, `${this.props.name}DiscountValue`);
            }
        }

        if (newProps.selectedCategoriesIds && this.props.selectedCategoriesIds !== newProps.selectedCategoriesIds) {
            if (newProps.selectedCategoriesIds.length !== 0) {
                this.validateCategories(newProps.selectedCategoriesIds);
            }
        }

        if ((this.props.campaign === null || this.props.campaign === undefined) && newProps.campaign) {
            this.setState({
                products: newProps.campaign.products,
                productCategories: newProps.campaign.productCategories,
                productsPriceByQuantity: newProps.campaign.productsPriceByQuantity
            });
        }

        if (this.props.applyForNonMember != newProps.applyForNonMember && newProps.applyForNonMember != null && newProps.applyForNonMember) {
            this.props.formInput(false, `${this.props.name}ApplyForMember`);
        }
        if (this.props.applyForMember != newProps.applyForMember && newProps.applyForMember != null && newProps.applyForMember) {
            this.props.formInput(false, `${this.props.name}ApplyForNonMember`);
        }
        if (this.props.applyOnlineOnly != newProps.applyOnlineOnly && newProps.applyOnlineOnly != null && newProps.applyOnlineOnly) {
            this.props.formInput(false, `${this.props.name}ApplyInStore`);
        }
        else if (this.props.applyInStoreOnly != newProps.applyInStoreOnly && newProps.applyInStoreOnly != null && newProps.applyInStoreOnly) {
            this.props.formInput(false, `${this.props.name}ApplyOnline`);
        }
    }

    componentDidMount() {
        if (this.props.isMedical) {
            this.props.getPriceMatrices();
        }
        this.props.clearFormErrors();
        this.props.getCategories(this.props.branchIds);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dialogProductType !== this.props.dialogProductType) {
            this.props.getCategories(this.props.branchIds);
        }

        if (prevProps.applyPriceByQuantity != null && prevProps.applyPriceByQuantity != this.props.applyPriceByQuantity && this.props.applyPriceByQuantity != null )
        {
            this.setState({products: [], productCategories: [], productsPriceByQuantity: []})
        }

        if (prevProps.allowMixAndMatch != null &&  prevProps.allowMixAndMatch != this.props.allowMixAndMatch && this.props.allowMixAndMatch != null )
        {
            this.setState({products: [], productCategories: [], productsPriceByQuantity: []})
        }
    }

    saveSuccess = () => {
        this.props.showSnackbar(this.state.status === "EDIT" ? LOOKUP.campaign.messages.editedMessage : LOOKUP.campaign.messages.createdMessage);
        this.redirectToCampaignList();
    }

    saveFailure = (msg) => {
        this.props.showError((
            <div>
                <p>Campaign could not be saved.</p>
                <p>{msg}</p>
            </div>)
            || LOOKUP.campaign.messages.saveErrorMessage);
    }

    redirectToCampaignList() {
        this.props.navigate("/manage/campaign");
    }

    closeProductsDialog = () => {
        this.setState({ dialogProducts: false });
        this.props.clearDialogItemsCampaign();
    }

    openProductsDialog = () => {
        this.setState({ dialogProducts: true });
        if (this.props.applyPriceByQuantity && this.props.allowMixAndMatch)
        {
            this.props.getCategories(this.props.branchIds);
        }
    }

    searchProducts = () => {
        if (this.props.productSearchText
            || this.props.categoryIdSearch
            || this.props.poSearchText
            || this.props.brandSearchText
            || this.props.weightSearch) {
            const model = {
                page: this.state.activePage,
                itemsPerPage: this.state.itemsPerPage,
                searchText: this.props.productSearchText,
                categoryId: this.props.categoryIdSearch ? parseInt(this.props.categoryIdSearch) : null,
                priceMatrixId: this.props.priceMatrixIdSearch,
                status: 'Active',
                typeId: null,
                orderBy: this.state.orderBy,
                sortBy: this.state.sortBy,
                branchIds: this.props.branchIds,
                poNumber: this.props.poSearchText,
                brandSearchText: this.props.brandSearchText,
                WeightPerUnit: this.props.weightSearch,
                weightStatus: (this.props.weightSearch === null) ? 0 : 1,
            };
            this.props.getProducts(model);
        }
        else {
            this.props.showError(
                <div>
                    <p>It is necessary to enter one of these fields for search: Product Name, Category, SKU, Brand, Weight, PO</p>
                </div>
            )
        }
    }

    search = () => {
        this.setState({ activePage: 1 }, this.searchProducts);
    }

    changePage = e => {
        this.setState({ activePage: e }, this.searchProducts);
    }

    addCategoriesToCampaign = () => {
        if (this.validateCategories()) {
            const categories = this.props.categoriesList.filter(c => this.props.selectedCategoriesIds.indexOf(c.id) !== -1);
            const updatedProductCategories = [...this.state.productCategories, ...categories];

            if (this.props.applyPriceByQuantity && this.props.allowMixAndMatch) {
                this.setState({ productCategories: updatedProductCategories }, this.validateItems);
            } else {    
                this.setState({ productCategories: updatedProductCategories, products: [] }, this.validateItems);
            }  
            
            this.closeProductsDialog();
        }
    }

    removeCategory = (category) => {
        const categories = this.state.productCategories.filter(c => c.id !== category.id);
        this.setState({ productCategories: categories });
    }

    removeProduct = (product) => {
        const products = this.state.products.filter(p => p.id !== product.id);
        this.setState({ products: products });
    }

    removeProductPriceByQuantity = (indexToRemove) => {
        const productsPriceByQuantity = this.state.productsPriceByQuantity.filter((p, index) => index !== indexToRemove);
        this.setState({ productsPriceByQuantity: productsPriceByQuantity });
    }

    validateCategories = (items) => {
        const valid = items ? items.length !== 0 : this.props.selectedCategoriesIds.length !== 0;
        this.setState({ errorSelectedCategories: !valid });
        return valid;
    };

    addProductToCampaign = (product) => {
        let products = [...this.state.products];
        products.push(product);
        if (this.props.applyPriceByQuantity && this.props.allowMixAndMatch) {
            this.setState({ products: products }, this.validateItems);
        } else {    
            this.setState({ productCategories: [], products: products, productsPriceByQuantity: [] }, this.validateItems);
        }   
        
    }

    addProductPriceByQuantity = (product) => {
        let productsPriceByQuantity = [...this.state.productsPriceByQuantity];

        let item = {
            id: 0, 
            productId: product.id,
            name: product.name,
            sku: product.sku,
            isNew: true
        }
        productsPriceByQuantity.push(item)
        this.setState({ productCategories: [], products: [], productsPriceByQuantity: productsPriceByQuantity }, this.validateItems);
    }

    addMixAndMatch = () => {
        let productsPriceByQuantity = [...this.state.productsPriceByQuantity];

        let item = {
            id: 0, 
            productId: null,
            name: null,
            sku: null,
            isNew: true
        }
        productsPriceByQuantity.push(item)
        this.setState({ productsPriceByQuantity: productsPriceByQuantity }, this.validateItems);
    }

    selectAllProducts = () => {
        let products = [...this.state.products];
        this.props.productsAll.map((item) => {
            if (products.filter(x => x.id == item.id).length == 0) {
                products.push(item);
            }
        });
        this.setState({ productCategories: [], products: products }, this.validateItems);
    }

    clearFilter = () => {
        this.props.clearDialogItemsCampaign();
    }

    saveCampaign = () => {
        const p = this.props;
        let campaign = p.campaignModel;
        //these settings must not be null when sent to backend but it needs to be null when switching settings to prevent UI issues
        campaign.ApplyPriceByQuantity = campaign.ApplyPriceByQuantity != null ? campaign.ApplyPriceByQuantity : false;
        campaign.AllowMixAndMatch = campaign.AllowMixAndMatch != null ? campaign.AllowMixAndMatch : false;
        campaign.IncrementalDiscount = campaign.IncrementalDiscount != null ? campaign.IncrementalDiscount : false;
        const campaignId = this.props.params.id || 0;

        const validators = [
            [`${p.name}Name`, campaign => (campaign.Name && campaign.Name !== null && campaign.Name !== ""), "Name"],
            [`${p.name}Type`, campaign => (campaign.Type && campaign.Type !== null && campaign.Type !== 0), "Type"],
            [`${p.name}StartDate`, campaign => (campaign.DateFrom && campaign.DateFrom !== null && campaign.DateFrom !== ""), "Start Date"],
        ];
        if (!p.applyPriceByQuantity) {

            validators.push(
            [`${p.name}DiscountType`, campaign => (campaign.DiscountType && campaign.DiscountType !== null && campaign.DiscountType !== 0), "Discount Type"],
            [`${p.name}DiscountValue`, campaign => (campaign.DiscountValue && campaign.DiscountValue !== null && campaign.DiscountValue !== 0), "Discount Value"]
            )
        } 

        const isFormValid = util.validate(validators, campaign, this.props.formError);
        const isItemsValid = this.validateItems();
        if (isItemsValid && isFormValid) {
            campaign.Id = campaignId;

            if (p.applyPriceByQuantity) {
                let productValidators = []
                let productsPriceByQuantity = this.state.productsPriceByQuantity;
                if (p.allowMixAndMatch){
                    productsPriceByQuantity = this.state.productsPriceByQuantity.filter(item => item.productId == null)
                    campaign.ProductsIds = this.state.products.map(item => parseInt(item.id));
                    campaign.ProductsCategoriesIds = this.state.productCategories.map(item => parseInt(item.id));
                } else {
                    productsPriceByQuantity = this.state.productsPriceByQuantity.filter(item => item.productId != null)
                }

                campaign.ProductsPriceByQuantity = productsPriceByQuantity.map((item, index) => {
                    let productName = item.isNew? `${p.name}Product${item.productId}-${index}` : `${p.name}Product${item.productId}-${item.id}`

                    let requiredQuantity = p.forms[productName + `RequiredQuantity`]
                    let discountType = p.forms[productName + `DiscountType`] 
                    let discountValue = p.forms[productName + `DiscountValue`]

                    return ({
                        id: item.id,
                        productId: p.allowMixAndMatch ? null : parseInt(item.productId),
                        requiredQuantity: requiredQuantity != "" && requiredQuantity != undefined ? parseInt(requiredQuantity) : null,
                        discountType: discountType,
                        discountValue: discountValue != "" && discountValue != undefined ? parseFloat(discountValue) : null,
                        isNew: item.isNew,
                        name: productName
                    })
                })

                campaign.ProductsPriceByQuantity.forEach((item, index) => {
                    let productName = item.isNew ? `${p.name}Product${item.productId}-${index}` : `${p.name}Product${item.productId}-${item.id}`

                    productValidators.push(
                        [productName + `RequiredQuantity`, 
                            model => { 
                                let modelRow = model.filter(x => x.name == productName);
                                return modelRow[0].requiredQuantity !== null && modelRow[0].requiredQuantity !== 0 
                            }, "This"],
                        [productName + `DiscountValue`, 
                            model => { 
                                let modelRow = model.filter(x => x.name == productName);
                                return modelRow[0].discountValue !== null && modelRow[0].discountValue !== 0 
                            }, "This"],
                    )
                }) 
                
                const isProductValid = util.validate(productValidators, campaign.ProductsPriceByQuantity, this.props.formError);

                if (isProductValid){
                    this.props.saveCampaign(campaign);
                } 
            }
            else {
                campaign.ProductsIds = this.state.products.map(item => parseInt(item.id));
                campaign.ProductsCategoriesIds = this.state.productCategories.map(item => parseInt(item.id));
                this.props.saveCampaign(campaign);
            }
        }
    }

    validateItems = () => {
        const isValid = this.props.allowMixAndMatch ? 
                ((this.state.productCategories.length > 0 || this.state.products.length > 0) && (this.state.productsPriceByQuantity.length > 0)) :
                (this.state.productCategories.length > 0 || (this.state.products.length > 0) || (this.state.productsPriceByQuantity.length > 0));
        this.setState({ errorNoAddedItems: !isValid });
        return isValid;
    }

    clearTime = () => {
        this.props.formInput(null, `${this.props.name}StartTime`);
        this.props.formInput(null, `${this.props.name}EndTime`);
        this.props.formError(`${this.props.name}StartTime`, ``);
        this.props.formError(`${this.props.name}EndTime`, ``);
    }

    render() {

        const categories = [{ text: "All", value: "0" }];

        this.props.categoriesList.map((c) => {
            categories.push({
                text: c.name,
                value: c.id.toString()
            });
        });

        const priceMatrices = (this.props.priceMatrices || []).map(p => ({
            text: p.name,
            value: p.id.toString()
        })
        );
        const weights = [{ text: "All", value: "none" }];
        LOOKUP.POSWeightList.map((item) => {
            weights.push({
                text: item.label,
                value: item.value
            });
        });
        const s = this.state;
        const p = this.props;
        const campaignType = LOOKUP.campaign.campaignType;
        const discountType = LOOKUP.campaign.discountType;
        if (!campaignType || !discountType) return null;
        const campaignDay = LOOKUP.campaign.day;
        const title = (this.state.status === 'ADD') ? LOOKUP.campaign.titles.add : LOOKUP.campaign.titles.edit;

        const productsTable = p.products.map(item => {
            return {
                sku: item.sku,
                name: item.name,
                typeCategory: `[${item.type}] ${item.category}`,
                price: item.price,
                icons: 
                this.props.applyPriceByQuantity && !this.props.allowMixAndMatch ? 
                    <Button name={`${this.props.name}${item.id}AddProductToCampaign`}
                        type="IconCheckButton"
                        className="campaign_add_btn_clicked"
                        onTouchTap={() => this.addProductPriceByQuantity(item)} />
                    :
                s.products.filter(p => p.id == item.id).length > 0
                    ? (
                        <Button name={`${this.props.name}${item.id}RemoveProductFromCampaign`}
                            type="IconCheckButton"
                            className="campaign_add_btn_clicked"
                            onTouchTap={() => this.removeProduct(item)}
                            icon={<DeleteIcon/>}
                        />)
                    : (
                        <Button name={`${this.props.name}${item.id}AddProductToCampaign`}
                            type="IconCheckButton"
                            className="campaign_add_btn"
                            icon={<CheckCircleIcon />}
                            onTouchTap={() => this.addProductToCampaign(item)} />
                    )
            };
        });

        /**
         * categoriesAddedTable to display the categories added to campaign
         * - added by Kate 2017-11-27 2:19PM
         */
        const categoriesAddedTable = s.productCategories.map((item, index) => {
            return {
                name: item.name,
                icons:
                    <Button
                        key={index}
                        name={`${this.props.name}${item.id}RemoveItemFromCampaign`}
                        type="IconDelete"
                        className="glyphicon-remove-circle"
                        onTouchTap={() => this.removeCategory(item)}
                        icon={<DeleteIcon/>}
                    />
            };
        });

        /**
        * productsAddedTable to display the products added to campaign
        * - added by Kate 2017-11-27 2:38PM
        */
        const productsAddedColumns = [...LOOKUP.campaign.productAddedTableColumns];

        if (p.applyPriceByQuantity && !p.allowMixAndMatch) {
            productsAddedColumns.splice(-1)
            productsAddedColumns.push(
                { key: "setPricing", label: "Set Pricing Rules" },
                { key: "icons", label: "" }
            )
        }

        const productsAddedColumnsMixAndMatch = [
            { key: "setPricing", label: "Set Pricing Rules" },
            { key: "icons", label: "" }
        ]

        const productsAddedTable = s.products.map((item, index) => {
            return {
                sku: item.sku,
                name: item.name,
                icons:
                    <Button
                        key={index}
                        name={`${p.name}${item.id}RemoveItemFromCampaign`}
                        type="IconDelete"
                        className="glyphicon glyphicon-remove-circle"
                        onTouchTap={() => this.removeProduct(item)}
                        icon={<DeleteIcon/>}
                    />
            };
        });


        let productsPriceByQuantity = s.productsPriceByQuantity;
        if (this.props.allowMixAndMatch){
            productsPriceByQuantity = productsPriceByQuantity.filter(item => item.productId == null)
            productsPriceByQuantity.push({newrowbutton: true})
        } else {
            productsPriceByQuantity = productsPriceByQuantity.filter(item => item.productId != null)
        }

        const productsPriceByQuantityTable = productsPriceByQuantity.map((item, index) => {
            let existingProductName = `${p.name}Product${item.productId}-${item.id}`;
            let newProductName = `${p.name}Product${item.productId}-${index}`;

            return {
                sku: item.sku,
                name: item.name,
                icons:
                    item.newrowbutton ? null :
                    <Button 
                        key={index} 
                        name={`${p.name}${item.productId}RemoveItemFromCampaign`}
                        type="IconDeleteButton" 
                        className="IconDeleteButton" 
                        onTouchTap={() => this.removeProductPriceByQuantity(index)} />,
                setPricing: (
                    item.newrowbutton ?
                    <div className="row">
                        <Button 
                            key={index} 
                            name={`${p.name}${item.productId}AddNewMixAndMatch`}
                            type="IconAddButton" 
                            className="IconDeleteButton" 
                            onTouchTap={() => this.addMixAndMatch()} />
                    </div>
                    :
                    <div className="row">
                        <div className="col-lg-4">
                            <MaskedTextInput
                                fullWidth={true}
                                name={item.isNew ? newProductName + `RequiredQuantity` : existingProductName + `RequiredQuantity`}
                                hintText="Minimum Quantity"
                                floatingLabelText="Minimum Quantity"
                                mask="99999"
                                min={2}
                                />
                        </div>
                        <div className="col-lg-4">
                        {
                            (item.isNew ? p.forms[newProductName + `DiscountType`] == CampaignDiscountType.Percentage :  p.forms[existingProductName + `DiscountType`] == CampaignDiscountType.Percentage) ? (
                                <MaskedTextInput
                                    fullWidth={true}
                                    name={item.isNew ? newProductName + `DiscountValue` : existingProductName + `DiscountValue`}
                                    floatingLabelText={`${LOOKUP.campaign.value.label} (%)`}
                                    label={`${LOOKUP.campaign.value.label} (%)`}
                                    hintText={`${LOOKUP.campaign.value.hintText} (%)`}
                                    mask="999"
                                    min={0}
                                    max={100} />
                            ) : (
                                <DecimalInput
                                    name={item.isNew ?  newProductName + `DiscountValue` : existingProductName + `DiscountValue`}
                                    fullWidth={true}
                                    floatingLabelText={`${LOOKUP.campaign.value.label} ($)`}
                                    label={`${LOOKUP.campaign.value.label} ($)`}
                                    hintText={`${LOOKUP.campaign.value.hintText} ($)`}
                                    min={0}
                                    max={1000000}
                                    required />
                            )
                        }
                        </div>
                        <div className="col-lg-4">
                            <SelectInput
                                name={item.isNew ? newProductName + `DiscountType` : existingProductName + `DiscountType`}
                                fullWidth={false}
                                options={
                                    [
                                        { text: "%", value: "1" },
                                        { text: "$", value: "2" }
                                    ]
                                }
                                floatingLabelText="Discount Type"
                                defaultValue={"1"}
                            /> 
                        </div>
                    </div>
                )
            };
        });
        
        return (
            <Grid headerContent={campaignEditCrumb}>
                <PageHeader title="Manage Campaigns" />
                <CardSimple title="Campaign" className="p-1">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <TextInput
                                name={p.name + "Name"}
                                label={LOOKUP.campaign.name.label}
                                floatingLabelText={LOOKUP.campaign.name.label}
                                hintText={LOOKUP.campaign.name.hintText}
                                fullWidth={true}
                                maxLength={50}
                                required />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <SelectInput
                                name={p.name + "Type"}
                                fullWidth={true}
                                id="selectCampaignType"
                                label="Type"
                                floatingLabelText="Type"
                                hintText="Type"
                                options={campaignType}
                                required
                            />
                        </div>
                    </div>
                    {/* .row */}
                    <div className="row">
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                            <DatePickerInput
                                name={p.name + "StartDate"}
                                id="inputStartDate"
                                floatingLabelText={LOOKUP.campaign.startDate.label}
                                hintText={LOOKUP.campaign.startDate.hintText}
                                fullWidth={true}
                                required
                            />
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                            <DatePickerInput
                                name={p.name + "EndDate"}
                                id="inputEndDate"
                                floatingLabelText={LOOKUP.campaign.endDate.label}
                                hintText={LOOKUP.campaign.endDate.hintText}
                                fullWidth={true}
                                minDate={p.campaignModel.DateFrom ? p.campaignModel.DateFrom : null}
                                required
                            />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                            {
                                campaignDay.map((item, index) => {
                                    return (
                                        <div className="campaign_day" key={index}>
                                            <CheckInput
                                                name={p.name + "WeekDay-" + item.text}
                                                text={item.name}
                                                value={item.text}
                                            />
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>{/* .row */}
                    <div className="row">
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                            <TimePickerInput
                                name={p.name + "StartTime"}
                                id="inputStartTime"
                                floatingLabelText={LOOKUP.campaign.startTime.label}
                                hintText={LOOKUP.campaign.startTime.hintText}
                                required
                            />
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                            <TimePickerInput
                                name={p.name + "EndTime"}
                                id="inputEndTime"
                                floatingLabelText={LOOKUP.campaign.endTime.label}
                                hintText={LOOKUP.campaign.endTime.hintText}
                                required
                            />
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 pa-1">
                            <Button
                                type="IconClearButton"
                                label="Clear Time"
                                fullWidth={true}
                                onTouchTap={() => this.clearTime()}
                            />
                        </div>
                    </div>
                    {
                        this.state.status === 'ADD' ? (
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                    <BranchMultiSelectAutoCompleteInput
                                        defaultValues={p.defaultBranch}
                                        name={p.name + LOOKUP.report.common.branchName}
                                        fullWidth={true}
                                        autoWidth={true}
                                        label="Branches"
                                        floatingLabelText="Branches"
                                        hintText="Branches"
                                        style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                                        options={p.branchOptions}
                                        fieldName={'Branches'}
                                    />
                                </div>
                            </div>) : ('')
                    }
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <TextInput
                                rows={1}
                                name={p.name + "Description"}
                                label={LOOKUP.campaign.description.label}
                                floatingLabelText={LOOKUP.campaign.description.label}
                                hintText={LOOKUP.campaign.description.hintText}
                                fullWidth={true}
                                maxLength={100}
                            />
                        </div>
                    </div>  {/* .row */}
                    
                    <div className="row">
                        <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-1">
                            <ToggleInput
                                name={p.name + "ApplyPriceByQuantity"}
                                label="Apply Price by Quantity"
                                className="campaign_apply_member btnToggleLabel"
                            />
                        </div>
                        { this.props.applyPriceByQuantity &&
                        <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-1">
                            <ToggleInput
                                name={p.name + "AllowMixAndMatch"}
                                label="Allow Mix-And-Match"
                                className="campaign_apply_member btnToggleLabel"
                            />
                        </div>}
                        { this.props.allowMixAndMatch && this.props.allowMixAndMatch && this.props.allowMixAndMatch &&
                        <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 mt-1">
                            <ToggleInput
                                name={p.name + "IncrementalDiscount"}
                                label="Incremental Discount"
                                className="campaign_apply_member btnToggleLabel"
                            />
                        </div>}
                    </div>
                    { !this.props.applyPriceByQuantity &&
                    <div className="row">
                        <div className="col-xs-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 campaign_status_group mr-2">
                            <ToggleInput
                                name={p.name + "ApplyForMember"}
                                label={LOOKUP.campaign.applyForMembersOnly}
                                className="toggle-yes-no btnToggleLabel"
                                option1="No"
                                option2="Yes"
                            />
                            {
                                this.props.buddiEnabled &&
                                <div>
                                    *Note: Member Pricing is only supported on TechPOS E-Commerce. If you are using a 3rd Party E-Commerce solution (ie: Buddi, Dutchi, Leafly), please do not activate the "Apply for Members Only" option.
                                </div>
                            }
                            <br />
                            </div>
                            <div className="col-xs-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 campaign_status_group mr-2">
                            <ToggleInput
                                name={p.name + "ApplyForNonMember"}
                                label={"Exclude Members"}
                                className="toggle-yes-no btnToggleLabel"
                                option1="No"
                                option2="Yes"
                            />
                        </div>
                        
                        <div className="col-xs-4 col-sm-4 col-md-3 col-lg-3 col-xl-3 campaign_status_group mr-2">
                            <ToggleInput
                                name={p.name + "ApplyOnline"}
                                label={LOOKUP.campaign.applyOnlineOnly}
                                className="toggle-yes-no btnToggleLabel"
                                option1="No"
                                option2="Yes"
                            />
                            <br />
                            <ToggleInput
                                name={p.name + "ApplyInStore"}
                                label={LOOKUP.campaign.applyInStoreOnly}
                                className="toggle-yes-no btnToggleLabel"
                                option1="No"
                                option2="Yes"
                            />
                            <br />
                        </div>
                    </div>}
                    <div className="row">
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 mr-2">
                            <ToggleInput
                                name={p.name + "Status"}
                                label={LOOKUP.campaign.status}
                                className="toggle-active-inactive btnToggleLabel"
                            />
                            <br />
                        </div>
                    </div>
                    {
                        this.props.wordpressEnabled &&
                        <div>
                            *You have wordpress enabled, the campaign update may take up to one day to show in wordpress site, if you want to push the latest price immediately, please go to warehouse page and click "WP INVENTORY UPDATE" button to trigger the push manually.
                        </div>
                    }
                    { !this.props.applyPriceByQuantity &&
                        <div className="row">
                            {
                                this.props.weedmapsEnable ? (
                                    <div>* You have enabled weedmaps, it only accepts percentage campaigns</div>
                                ) : ("")
                            }
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <SelectInput
                                    name={p.name + "DiscountType"}
                                    id="selectDiscountType"
                                    fullWidth={true}
                                    label="Type"
                                    floatingLabelText="Discount Type"
                                    hintText="Discount Type"
                                    options={discountType}
                                    required
                                />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                {
                                    p.campaignModel && p.campaignModel.DiscountType === CampaignDiscountType.Percentage ? (
                                        <MaskedTextInput
                                            fullWidth={true}
                                            name={`${p.name}DiscountValue`}
                                            id="inputDiscountValue"
                                            floatingLabelText={`${LOOKUP.campaign.value.label} (%)`}
                                            label={`${LOOKUP.campaign.value.label} (%)`}
                                            hintText={`${LOOKUP.campaign.value.hintText} (%)`}
                                            mask="999"
                                            min={0}
                                            max={100} />
                                    ) : (
                                        <DecimalInput
                                            name={`${p.name}DiscountValue`}
                                            fullWidth={true}
                                            id="inputDiscountValue"
                                            floatingLabelText={`${LOOKUP.campaign.value.label} ($)`}
                                            label={`${LOOKUP.campaign.value.label} ($)`}
                                            hintText={`${LOOKUP.campaign.value.hintText} ($)`}
                                            min={0}
                                            max={1000000}
                                            required />
                                    )
                                }
                            </div>
                        </div>
                    }       
                </CardSimple>
                <CardSimple className="mt-2 pa-1">
                    <div className="row">
                        <div className="col-sm-8">
                            <h4>Items added to Campaign</h4>
                        </div>
                        <div className="col-sm-4 text-right">
                            <Button
                                type="FloatButton"
                                label="Add Items To Campaign"
                                className="btnNewBrandPOS"
                                fullWidth
                                onTouchTap={() => this.openProductsDialog()}
                            />
                        </div>
                    </div>
                    {
                        (!this.props.applyPriceByQuantity && s.productCategories.length === 0 && s.products.length === 0) || (this.props.applyPriceByQuantity && s.productsPriceByQuantity.length === 0) ? (
                            <div className="row">
                                <p>No items added to this campaign</p>
                            </div>
                        ) : null
                    }
                    {
                        s.errorNoAddedItems ? (
                            <div>
                                <p className="danger">Please add at least one product or category to the campaign.</p>
                                {this.props.allowMixAndMatch && <p className="danger">For Mix-and-match, please add at least one pricing rule.</p>}
                            </div>
                        ) : null
                    }
                    {
                        this.props.applyPriceByQuantity && (this.props.allowMixAndMatch || s.productsPriceByQuantity.length > 0) ? (
                            <div className="row">
                                <div className="col-lg-12">
                                    <p>Note: All products above the minimum quantity will be discounted.</p>
                                    {this.props.allowMixAndMatch && 
                                        <div>
                                            <p>For Mix-And-Match, all products and categories listed below will follow the same rules.</p>
                                            <p>If Incremental Discount is Active, only the rule with the lowest Minimum Quantity will be applied. For example, if Minimum Quantity is 2, discount will be applied for every 2 items purchased.</p>
                                        </div>
                                        }
                                    <label>{this.props.allowMixAndMatch ? "Mix and Match rules:" : "Products Added:" }</label>
                                    <GenericTable
                                        compName="productsAddedTable"
                                        className={"campaign_added_product_table tableHeaderwhiteColorFont campaign_added_product_table_price_by_quantity"}
                                        adjustForCheckbox={false}
                                        displaySelectAll={false}
                                        displayRowCheckbox={false}
                                        enableSelectAll={false}
                                        multiSelectable={false}
                                        selectable={false}
                                        columns={this.props.allowMixAndMatch ? productsAddedColumnsMixAndMatch : productsAddedColumns}
                                        rows={productsPriceByQuantityTable}
                                    />
                                </div>
                            </div>
                        ) : null
                    }
                    
                    {
                        (!this.props.applyPriceByQuantity || (this.props.applyPriceByQuantity && this.props.allowMixAndMatch)) && s.productCategories.length > 0 ? (
                            <div className="row">
                                <div className="col-xs-12" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <p className="mb-1">Product Categories Added: </p>
                                    <GenericTable
                                        compName="categoriesAddedTable"
                                        adjustForCheckbox={false}
                                        displaySelectAll={false}
                                        displayRowCheckbox={false}
                                        enableSelectAll={false}
                                        multiSelectable={false}
                                        selectable={false}
                                        columns={LOOKUP.campaign.categoryAddedTableColumns}
                                        rows={categoriesAddedTable}
                                        stripedRows={true}
                                    />
                                </div>
                            </div>
                        ) : null
                    }
                    {
                        (!this.props.applyPriceByQuantity || (this.props.applyPriceByQuantity && this.props.allowMixAndMatch)) && s.products.length > 0 ? (
                            <div className="row">
                                <div className="col-xs-12" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <p className="mb-1">Products Added: </p>
                                    <GenericTable
                                        compName="productsAddedTable"
                                        className={"campaign_added_product_table tableHeaderwhiteColorFont"}
                                        adjustForCheckbox={false}
                                        displaySelectAll={false}
                                        displayRowCheckbox={false}
                                        enableSelectAll={false}
                                        multiSelectable={false}
                                        selectable={false}
                                        columns={productsAddedColumns}
                                        rows={productsAddedTable}
                                        stripedRows={true}
                                    />
                                </div>
                            </div>
                        ) : null
                    }
                    {/* {
                        this.props.applyPriceByQuantity && !this.props.allowMixAndMatch && s.productsPriceByQuantity.length > 0 && !this.props.weedmapsEnable ? (
                            <div className="row">
                                <div className="col-lg-12">
                                    <p>Note: All products above the minimum quantity will be discounted.</p>
                                    <label>{"Products Added:" }</label>
                                    <GenericTable
                                        compName="productsAddedTable"
                                        className={"campaign_added_product_table tableHeaderwhiteColorFont campaign_added_product_table_price_by_quantity"}
                                        adjustForCheckbox={false}
                                        displaySelectAll={false}
                                        displayRowCheckbox={false}
                                        enableSelectAll={false}
                                        multiSelectable={false}
                                        selectable={false}
                                        columns={productsAddedColumns}
                                        rows={productsPriceByQuantityTable}
                                    />
                                </div>
                            </div>
                        ) : null
                    } */}
                </CardSimple>
                <PageBottomWithButtons>
                    <Button
                        name="buttonSave"
                        className="pull-right btnNewBrandPOS"
                        label={LOOKUP.campaign.controls.saveButon}
                        primary={true}
                        onTouchTap={() => this.saveCampaign()}
                    // disabled={!this.isPwdValid()}
                    />
                    <Button
                        type="CancelButton"
                        name="buttonCancel"
                        className="pull-right btn-space btnCancelOperation"
                        label={LOOKUP.common.cancel.text}
                        onTouchTap={() => this.redirectToCampaignList()}
                    />
                </PageBottomWithButtons>
                {/* DIALOG PRODUCTS */}
                <DialogInput
                    title={<DialogHeader text="Add To Campaign" />}
                    modal={true}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '980' }}
                    actions={[
                        <Button
                            name="buttonClose"
                            label="Close"
                            primary={false}
                            className="btnCleanSearch"
                            onTouchTap={() => this.closeProductsDialog()} />
                    ]}
                    contentStyle={{ width: '95%', maxWidth: 'none' }}
                    open={this.state.dialogProducts}>
                        { !this.props.applyPriceByQuantity &&
                        <div className="row">
                            <div className="col-lg-12">
                                <p className="mt-2 guide-text">First, choose if you want to add product categories or specific products to this campaign:</p>
                                <RadioInput 
                                    groupName={`${p.name}DialogProductType`}
                                    className="pos_refund_radio rdBtnLabels"
                                    options={[{ text: "By Product Category", value: '1' }, { text: "By Product", value: '2' }]}
                                    defaultValue="1"
                                />
                            </div>
                            <hr />
                        </div>
                        }
                        {
                            (!this.props.applyPriceByQuantity && p.dialogProductType === "1") || (this.props.applyPriceByQuantity && this.props.allowMixAndMatch) ? (
                                <div className="row">
                                    {
                                        p.categoriesList.map((item, index) => {
                                            return (
                                                <div className="col-lg-6" key={index}>
                                                    <CheckInput
                                                        name={p.name + "ProductCategory-" + item.id}
                                                        text={item.name}
                                                        className="selectCampaignItems"
                                                        value={item.id}
                                                    />
                                                </div>
                                            );
                                        })
                                    }
                                    <div className="col-lg-12 mb-2">
                                        {
                                            s.errorSelectedCategories === true ? (
                                                <p className="validationMessage ml-1">Please choose at least one category</p>
                                            ) : null
                                        }
                                        <Button
                                            className="pull-right mr-1"
                                            name="buttonAddItem"
                                            label="Add to campaign"
                                            primary={true}
                                            onTouchTap={() => this.addCategoriesToCampaign()} />
                                    </div>
                                </div>
                            ) : null
                        }
                        {
                            this.props.applyPriceByQuantity || p.dialogProductType === "2" ? (
                                <div>
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-7 col-lg-6 col-xl-7">
                                            <TextInput
                                                name={`${p.name}CampaignProductSearchText`}
                                                fullWidth={true}
                                                label={LOOKUP.campaign.filters.productName.label}
                                                floatingLabelText={LOOKUP.campaign.filters.productName.label}
                                                hintText={LOOKUP.campaign.filters.productName.hintText} />
                                        </div>
                                        <div className="col-md-5 col-lg-6 col-xl-5">
                                            <Button
                                                className="pull-right mr-2 mb-1"
                                                name="searchProductDialog"
                                                label="Search"
                                                primary={true}
                                                onTouchTap={() => this.search()}
                                            />
                                            <Button
                                                className="pull-right mr-2 mb-2"
                                                name="buttonAddItem"
                                                label={<span style={{ whiteSpace: `nowrap`, color: `white` }}>SELECT ALL</span>}
                                                primary={true}
                                                onTouchTap={() => this.selectAllProducts()}
                                            />
                                            <Button
                                                className="pull-right mr-1 mb-2"
                                                name="buttonClearItem"
                                                label={<span style={{ whiteSpace: `nowrap`, color: `white` }}>Clear Filter</span>}
                                                primary={true}
                                                onTouchTap={() => this.clearFilter()}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                                            <SelectInput name={`${p.name}CategorySearch`}
                                                         label={LOOKUP.product.filters.category.label}
                                                         className="smallerPlaceholder"
                                                         floatingLabelText={LOOKUP.product.filters.category.label}
                                                         hintText={LOOKUP.product.filters.category.hintText}
                                                         options={categories}
                                                         fullWidth={true} />
                                        </div>
                                        {
                                            this.props.isMedical ? (
                                                <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                                                    <SelectInput name={`${p.name}PriceMatrixSearch`}
                                                        fullWidth={true}
                                                        className="smallerPlaceholder"
                                                        floatingLabelText={"Price Matrix"}
                                                        label={LOOKUP.product.priceMatrix.label}
                                                        options={priceMatrices}
                                                        hintText={LOOKUP.product.priceMatrix.hintText} />
                                                </div>
                                            ) : ""
                                        }

                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                            <TextInput
                                                name={`${p.name}PoSearchText`}
                                                label={LOOKUP.campaign.filters.po.label}
                                                floatingLabelText={LOOKUP.campaign.filters.po.label}
                                                hintText={LOOKUP.campaign.filters.po.hintText}
                                                maxLength={50}
                                                fullWidth={true}
                                            />
                                        </div>
                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                                            <SelectInput name={`${p.name}WeightSearch`}
                                                label={LOOKUP.product.weight.label}
                                                floatingLabelText={LOOKUP.product.weight.label}
                                                hintText={LOOKUP.product.weight.hintText}
                                                className="smallerPlaceholder"
                                                options={weights}
                                                fullWidth={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                                            <TextInput
                                                name={`${p.name}BrandSearchText`}
                                                label={LOOKUP.campaign.filters.brand.label}
                                                floatingLabelText={LOOKUP.campaign.filters.brand.label}
                                                hintText={LOOKUP.campaign.filters.brand.hintText}
                                                maxLength={50}
                                                fullWidth={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mt-1">
                                        <div className="col-lg-12">
                                            <GenericTable
                                                className="table_center tableHeaderwhiteColorFont"
                                                compName="productDialogListTable"
                                                adjustForCheckbox={false}
                                                displaySelectAll={false}
                                                displayRowCheckbox={false}
                                                enableSelectAll={false}
                                                multiSelectable={false}
                                                selectable={false}
                                                stripedRows={true}
                                                columns={LOOKUP.campaign.productDialogTableColumns}
                                                rows={productsTable} />
                                            <Pagination
                                                length={p.productsLength || 0}
                                                itemsPerPage={s.itemsPerPage}
                                                activePage={s.activePage}
                                                onPageChange={(e) => this.changePage(e)} />
                                        </div>
                                    </div>
                                </div>
                            ) : null
                        }
                </DialogInput>
            </Grid>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    let defaultBranch = [];
    defaultBranch.push({ text: state.common.branchId.toString(), value: state.common.branchId.toString() });

    return {
        forms: state.form,
        branchOptions: branchOptions,
        campaign: state.entity.compaign,
        defaultBranch: defaultBranch,
        categoriesList: state.entity.categoriesList || [],
        campaignModel: selectCampaignModel(state, ownProps.name),
        dialogProductType: state.form[`${ownProps.name}DialogProductType`] || `1`,
        selectedCategoriesIds: selectCampaignSelectedCategories(state.form, ownProps.name),
        priceMatrices: state.entity.priceMatricesList,
        products: state.entity.productList || [],
        productsLength: state.entity.productListLength,
        productsAll: state.entity.productListAll || [],
        branchIds: state.form[`${ownProps.name}BranchOption`] ? state.form[`${ownProps.name}BranchOption`].join(",") : state.common.branchId,
        saveSuccess: state.form[`${ownProps.name}SaveSuccess`],
        saveError: state.form[`${ownProps.name}SaveError`],
        saveTimeStamp: state.form[`${ownProps.name}SaveTimeStamp`],
        selectedBranchOption: state.form[`${ownProps.name}BranchOption`],
        poSearchText: state.form[`${ownProps.name}PoSearchText`],
        brandSearchText: state.form[`${ownProps.name}BrandSearchText`],
        weightSearch: state.form[`${ownProps.name}WeightSearch`] ? parseFloat(state.form[`${ownProps.name}WeightSearch`]) : null,
        productSearchText: state.form[`${ownProps.name}CampaignProductSearchText`],
        categoryIdSearch: state.form[`${ownProps.name}CategorySearch`] ? parseInt(state.form[`${ownProps.name}CategorySearch`]) : null,
        priceMatrixIdSearch: state.form[`${ownProps.name}PriceMatrixSearch`] ? parseInt(state.form[`${ownProps.name}PriceMatrixSearch`]) : null,
        isMedical: state.common.applicationSettings.isMedical,
        weedmapsEnable: state.common.applicationSettings.weedmapsEnable,
        buddiEnabled: state.common.applicationSettings.buddiEnabled,
        wordpressEnabled: state.common.applicationSettings.wordpressEnabled,
        applyForNonMember: state.form[`${ownProps.name}ApplyForNonMember`],
        applyForMember: state.form[`${ownProps.name}ApplyForMember`],
        applyPriceByQuantity: state.form[`${ownProps.name}ApplyPriceByQuantity`],
        allowMixAndMatch: state.form[`${ownProps.name}AllowMixAndMatch`],
        applyOnlineOnly: state.form[`${ownProps.name}ApplyOnline`],
        applyInStoreOnly: state.form[`${ownProps.name}ApplyInStore`]
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {

    return {
        saveCampaign: (model) => dispatch(saveBulkCampaign(model, ownProps.name)),
        getCampaign: (id, branchId) => dispatch(getCampaign(id, branchId, ownProps.name)),
        getPriceMatrices: () => dispatch(getPriceMatrices()),
        init: (compName) => dispatch(initializeCampaignForm(compName)),
        clearFormErrors: () => dispatch(clearFormErrors()),
        formError: (name, error) => dispatch(formError(name, error)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCategories: (branchIds) => dispatch(getCategoriesByBranchs(branchIds)),
        getProducts: (model) => dispatch(getProductsCampaign(model)),
        clearDialogItemsCampaign: () => dispatch(clearDialogItemsCampaign(ownProps.name)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(CampaignSave));
